import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer" }
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_7 = { class: "row mb-7" }
const _hoisted_8 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_9 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_10 = { class: "d-none" }
const _hoisted_11 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6" }
const _hoisted_12 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-title m-0" }, [
        _createElementVNode("h3", { class: "fw-bolder m-0" }, "Profile Details")
      ], -1)),
      _createVNode(_component_router_link, {
        to: "/examples/account/settings",
        class: "btn btn-primary align-self-center"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Edit Profile", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Full Name", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.user.cTenTaiKhoan != undefined ? _ctx.user.cTenTaiKhoan : ""), 1)
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row mb-7" }, [
        _createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Company"),
        _createElementVNode("div", { class: "col-lg-8 fv-row" }, [
          _createElementVNode("span", { class: "fw-bold fs-6" }, "Keenthemes")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, [
          _createTextVNode(" Contact Phone "),
          _createElementVNode("i", {
            class: "fas fa-exclamation-circle ms-1 fs-7",
            "data-bs-toggle": "tooltip",
            title: "Phone number must be active"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user.cSoDienThoai != undefined ? _ctx.user.cSoDienThoai : ""), 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "badge badge-success" }, "Verified", -1))
        ])
      ]),
      _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\">Company Site</label><div class=\"col-lg-8\"><a href=\"https://keenthemes.com\" target=\"_blank\" class=\"fw-bold fs-6 text-dark text-hover-primary\">keenthemes.com</a></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\"> Country <i class=\"fas fa-exclamation-circle ms-1 fs-7\" data-bs-toggle=\"tooltip\" title=\"Country of origination\"></i></label><div class=\"col-lg-8\"><span class=\"fw-bolder fs-6 text-dark\">Germany</span></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\">Communication</label><div class=\"col-lg-8\"><span class=\"fw-bolder fs-6 text-dark\">Email, Phone</span></div></div><div class=\"row mb-10\"><label class=\"col-lg-4 fw-bold text-muted\">Allow Changes</label><div class=\"col-lg-8\"><span class=\"fw-bold fs-6\">Yes</span></div></div>", 4)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\">We need your attention!</h4><div class=\"fs-6 text-gray-600\"> Your payment was declined. To start using tools, please <a class=\"fw-bolder\" href=\"#\">Add Payment Method</a>. </div></div></div>", 1))
        ])
      ])
    ])
  ]))
}